import { useTemporaryCsvObjectUrl } from 'src/lib/hooks/useTemporaryCsvObjectUrl';

const CSV_TEMPLATE = [
  [
    'Campaign (optional)',
    'Subject',
    'Email Body',
    'Sent',
    'Delivered',
    'Opened',
    'Clicked',
    'Date',
  ],
  [
    'Campaign name',
    'Paste the subject line of the email here',
    'Paste the content of your email here',
    '100000',
    '9000',
    '4640',
    '119',
    '2023-07-27 12:33:47',
  ],
  [
    'Campaign name',
    'Paste the subject line of the email here',
    'Paste the content of your email here',
    '100000',
    '9000',
    '4640',
    '119',
    '2023-07-27 12:33:47',
  ],
];

// Creating an object for downloading url
export const useCsvTemplateUrl = () => {
  return useTemporaryCsvObjectUrl(CSV_TEMPLATE, { mimeType: 'text/csv' });
};
